/** Resolve a visitor's initial language without overwriting explicit preferences. */
export const SUPPORTED_LANGUAGES = ["en", "el", "fr", "de", "it", "es", "ja"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

function supportedLanguage(value: string | null | undefined): SupportedLanguage | null {
  const primary = value?.trim().toLowerCase().split(/[-_]/, 1)[0];
  return SUPPORTED_LANGUAGES.find((code) => code === primary) ?? null;
}

/**
 * Explicit saved choice wins; otherwise use the browser's preference order.
 * An unsupported language falls through to the next preference, then English.
 * Detection itself does not persist anything: only an explicit switch should.
 */
export function resolveInitialLanguage(
  savedPreference: string | null | undefined,
  browserLanguages: readonly string[] = [],
): SupportedLanguage {
  const saved = supportedLanguage(savedPreference);
  if (saved) return saved;

  for (const language of browserLanguages) {
    const supported = supportedLanguage(language);
    if (supported) return supported;
  }
  return "en";
}
